"use client";

import { BuilderComponent } from "@builder.io/react";
import { initializeBuilder } from "@faire/builder-core/BuilderComponents/initializeBuilder";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { useMergedRefs } from "@faire/web/ui/hooks/useMergedRefs";
import React, { Suspense, use } from "react";

import { RenderBuilderWithSSRProps } from "./types";

const SuspendingRenderBuilderWithSSR: React.FC<RenderBuilderWithSSRProps> = ({
  builderIOApiKey,
  modelName,
  builderPromise,
  data,
  className,
  onViewEvent,
  loadTimingRef,
}) => {
  //reinitialize builder on client side to make preview work
  initializeBuilder(builderIOApiKey);

  const onViewEventRef = useDoActionWhenVisible(onViewEvent);
  const ref = useMergedRefs(loadTimingRef, onViewEventRef);
  const builderContent = use(builderPromise);

  return (
    <div className={className} ref={ref}>
      <BuilderComponent
        content={builderContent}
        model={modelName}
        data={data}
      />
    </div>
  );
};

export const RenderBuilderWithSSR: React.FC<RenderBuilderWithSSRProps> = (
  props
) => {
  if (!props.builderPromise) {
    return null;
  }
  return (
    <Suspense fallback={props.suspenseFallback}>
      {/* carousel and other widets are lazy loaded, so we need suspense  */}
      <SuspendingRenderBuilderWithSSR {...props} />
    </Suspense>
  );
};
